import React from 'react';
import { Input, Select, TreeSelect, DatePicker, Tag, Tooltip, Row, Col } from 'antd';
import { isEmpty, dateFormat } from '../Service/Utils';
import moment from 'moment';
import 'moment/locale/zh-cn';

function PlattenInput(props) {
    const originVals = props.value === undefined ? [] : props.value;
    const values = new Set(originVals);
    return <div style={{ lineHeight: 2 }}>

        {/* {props.options.map(opt => <Tag.CheckableTag
            key={opt.value}
            checked={values.has(opt.value)}
            onChange={checked => {
                if (checked) {
                    props.onChange([opt.value, ...originVals]);
                } else {
                    props.onChange(originVals.filter(v => v !== opt.value));
                }
            }}
        >{opt.title}</Tag.CheckableTag>) */}
        {props.options?.map(opt => <span
            key={opt.value}
            style={{
                margin: '5px 5px 0 0',
                padding: values.has(opt.value) ? '4px 9px 4px 9px' : '5px 10px 5px 10px',
                minWidth: 60,
                maxWidth: 96,
                backgroundColor: '#f0f0f0',
                border: (values.has(opt.value) && '1px solid #1890ff'),
                color: (values.has(opt.value) && '#1890ff'),
                cursor: props.disabled ? 'not-allowed' : 'pointer',
                position: 'relative',
                fontSize: 12
            }}
            onClick={() => {
                if (props.disabled) {
                    return;
                }
                if (values.has(opt.value)) {
                    props.onChange(originVals.filter(v => v !== opt.value));
                } else {
                    props.onChange([opt.value, ...originVals]);
                }
            }}
        ><span
            style={{
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
            }}
        >{opt.title}</span>
            {values.has(opt.value) && <i
                style={{
                    color: '#4D88F',
                    position: 'absolute',
                    right: -1,
                    bottom: -8
                }}
            >
                <svg class="svg-icon" viewBox="0 0 1024 1024" aria-hidden="true" width="1em" height="1em" fill="currentColor">
                    <path d="M1024 0L0 1024h1024z" fill="#2153D4"></path>
                    <path d="M820.150857 585.142857l57.563429 58.514286-88.795429 90.185143 84.041143 85.357714-57.563429 58.514286L731.428571 792.356571 647.460571 877.714286l-57.563428-58.514286 83.968-85.357714L585.142857 643.657143l57.563429-58.514286L731.428571 675.401143 820.150857 585.142857z" fill="#BCCBF2"></path>
                </svg>
            </i>}
        </span>)}
    </div>;
}

const placeholderOptions = {
    IDENTITY: [
        {
            value: '大学生',
            title: '大学生'
        }, {
            value: '初中生',
            title: '初中生'
        }, {
            value: '高中生',
            title: '高中生'
        }, {
            value: '小学生',
            title: '小学生'
        }, {
            value: '工作党',
            title: '工作党'
        }, {
            value: '其他',
            title: '其他'
        }, {
            value: 'NULL',
            title: 'NULL'
        }
    ],
    DEVICE_KIND: [
        {
            value: 'android',
            title: 'Android'
        }, {
            value: 'ipad',
            title: 'iPad'
        }, {
            value: 'iphone',
            title: 'iPhone'
        }, {
            value: 'NULL',
            title: 'NULL'
        }
    ],
    SEX: [
        {
            value: '男',
            title: '男'
        }, {
            value: '女',
            title: '女'
        }, {
            value: 'NULL',
            title: 'NULL'
        }
    ],
    YES_OR_NO: [
        {
            value: '是',
            title: '是'
        }, {
            value: '否',
            title: '否'
        }, {
            value: 'NULL',
            title: 'NULL'
        }
    ],
    CITY_LEVEL: [
        {
            value: '一线城市',
            title: '一线城市'
        }, {
            value: '新一线城市',
            title: '新一线城市'
        }, {
            value: '二线城市',
            title: '二线城市'
        }, {
            value: '三线城市',
            title: '三线城市'
        }, {
            value: '四线城市',
            title: '四线城市'
        }, {
            value: '五线城市',
            title: '五线城市'
        }, {
            value: 'NULL',
            title: 'NULL'
        }
    ],
    DEVICE_PRICE: [
        {
            value: '500-999',
            title: '¥500-999'
        }, {
            value: '1000-1499',
            title: '¥1000-1499'
        }, {
            value: '1500-1999',
            title: '¥1500-1999'
        }, {
            value: '2000-2999',
            title: '¥2000-2999'
        }, {
            value: '3000-3999',
            title: '¥3000-3999'
        }, {
            value: '4000-4999',
            title: '¥4000-4999'
        }, {
            value: '5000+',
            title: '¥5000+'
        }, {
            value: 'NULL',
            title: 'NULL'
        }
    ],
    AD_KIND: [
        {
            value: '实验广告',
            title: 'prod'
        }, {
            value: '正式广告',
            title: 'test'
        }
    ],
    USER_GRADE: [
        { value: "幼儿园小班", title: '幼儿园小班' },
        { value: "幼儿园中班", title: '幼儿园中班' },
        { value: "幼儿园大班", title: '幼儿园大班' },
        { value: "小学一年级", title: '小学一年级' },
        { value: "小学二年级", title: '小学二年级' },
        { value: "小学三年级", title: '小学三年级' },
        { value: "小学四年级", title: '小学四年级' },
        { value: "小学五年级", title: '小学五年级' },
        { value: "小学六年级", title: '小学六年级' },
        { value: "初中一年级", title: '初中一年级' },
        { value: "初中二年级", title: '初中二年级' },
        { value: "初中三年级", title: '初中三年级' },
        { value: "高中一年级", title: '高中一年级' },
        { value: "高中二年级", title: '高中二年级' },
        { value: "高中三年级", title: '高中三年级' },
        { value: "大学生", title: '大学生' },
        { value: "大学一年级", title: '大学一年级' },
        { value: "大学二年级", title: '大学二年级' },
        { value: "大学三年级", title: '大学三年级' },
        { value: "大学四年级", title: '大学四年级' },
        { value: "研究生", title: '研究生' },
        { value: "博士生", title: '博士生' },
        { value: "NULL", title: 'NULL' },
    ]
};

function PlaceholderFlattenInput(props) {
    const placeholder = props.placeholder;
    switch (placeholder.format) {
        case 'BCZ_STAFF_UID':
            return <Select
                disabled={props.disabled}
                mode="multiple"
                allowClear
                showSearch
                style={{ width: '100%', minWidth: 160, fontSize: 12 }}
                placeholder="员工"
                value={props.value}
                size="small"
                onChange={props.onChange}
            >
                {props.md.staffs?.map(staff => <Select.Option key={staff.id}>{staff.name}</Select.Option>)}
            </Select>;
        case 'IDENTITY':
        case 'DEVICE_KIND':
        case 'SEX':
        case 'YES_OR_NO':
        case 'CITY_LEVEL':
        case 'DEVICE_PRICE':
        case 'AD_KIND':
            return <PlattenInput
                disabled={props.disabled}
                value={props.value}
                onChange={props.onChange}
                options={placeholderOptions[placeholder.format]} />;
        case 'PROVINCE':
            return <Select
                disabled={props.disabled}
                mode="multiple"
                allowClear
                showSearch
                style={{ width: '100%', minWidth: 160, fontSize: 12 }}
                placeholder="选择省份"
                value={props.value}
                size="small"
                onChange={props.onChange}
            >
                {props.md.provinces?.map(province => <Select.Option key={province.title}>{province.title}</Select.Option>)}
                <Select.Option value="NULL">NULL</Select.Option>
            </Select>;
        case 'BCZ_WORD_BOOK': // bookCategories
            return <TreeSelect
                disabled={props.disabled}
                showSearch
                style={{ width: '100%', minWidth: 160, fontSize: 12 }}
                value={props.value}
                size="small"
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder="选择词书"
                allowClear
                multiple
                treeDefaultExpandAll
                onChange={props.onChange}
            >
                {props.md.bookCategories?.map(category =>
                    <TreeSelect.TreeNode
                        value={category.key}
                        title={category.title}
                    >
                        {category.children.map(book =>
                            <TreeSelect.TreeNode
                                key={book.key}
                                value={book.title}
                                title={book.title}
                            />)}
                    </TreeSelect.TreeNode>)}
            </TreeSelect>;
        case 'CITY':
            return <TreeSelect
                disabled={props.disabled}
                showSearch
                style={{ width: '100%', minWidth: 160, fontSize: 12 }}
                value={props.value}
                size="small"
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder="选择城市"
                allowClear
                multiple
                treeDefaultExpandAll
                onChange={props.onChange}
            >
                {props.md.provinces?.map((province) =>
                    <TreeSelect.TreeNode value={province.key} title={province.title}>
                        {province.children.map(city =>
                            <TreeSelect.TreeNode value={city.title} title={city.title} />)}
                    </TreeSelect.TreeNode>)}
            </TreeSelect>;
        case 'AD_POSITION':
            return <TreeSelect
                disabled={props.disabled}
                showSearch
                style={{ width: '100%', minWidth: 160, fontSize: 12 }}
                value={props.value}
                size="small"
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder="请选择广告位"
                allowClear
                multiple
                treeDefaultExpandAll
                onChange={props.onChange}
            >
                {props.md.adSlots?.map((app) =>
                    <TreeSelect.TreeNode value={app.key} title={app.title}>
                        {app.children.map(slot =>
                            <TreeSelect.TreeNode value={slot.title} title={slot.title} />)}
                    </TreeSelect.TreeNode>)}
            </TreeSelect>;
        case 'TO_GROUP':
        case 'FROM_GROUP':
            return <PlattenInput
                disabled={props.disabled}
                value={props.value}
                onChange={props.onChange}
                options={props.md.toGroupsToObjects?.map(toGroup => { return { value: toGroup.key, title: toGroup.title }; })} />;
        case 'TO_OBJECT':
            return <TreeSelect
                disabled={props.disabled}
                showSearch
                style={{ width: '100%', minWidth: 160, fontSize: 12 }}
                value={props.value}
                size="small"
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder="请选择承接对象"
                allowClear
                multiple
                treeDefaultExpandAll
                onChange={props.onChange}
            >
                {props.md.toGroupsToObjects?.map((toGroup) =>
                    <TreeSelect.TreeNode value={toGroup.key} title={toGroup.title}>
                        {toGroup.children.map(toObject =>
                            <TreeSelect.TreeNode value={toObject.key} title={toObject.title} />)}
                    </TreeSelect.TreeNode>)}
            </TreeSelect>;
        case 'USER_GRADE':
            return <Select
                disabled={props.disabled}
                value={props.value}
                showSearch
                mode="multiple"
                allowClear
                size="small"
                placeholder="请选择年级"
                style={{ width: '100%' }}
                onChange={props.onChange}
            >
                {placeholderOptions.USER_GRADE.map(opt => <Select.Option value={opt.value}>{opt.title}</Select.Option>)}
            </Select>;
        case 'MULTI_INPUT':
        case 'LIKE_INPUT':
        case 'INPUT':
            return <Input
                disabled={props.disabled}
                value={props.value}
                allowClear
                size="small"
                style={{ width: '100%', fontSize: 12, minWidth: 90, maxWidth: 328 }}
                onChange={({ target: { value } }) => props.onChange(value)}
            />;
        case 'DATE_RANGE':
            return <DatePicker.RangePicker
                size='small'
                value={props.value === undefined
                    ? undefined
                    : [moment(props.value[0], dateFormat), moment(props.value[1], dateFormat)]}
                onChange={dates => {
                    props.onChange(isEmpty(dates)
                        ? undefined
                        : [dates[0].format(dateFormat), dates[1].format(dateFormat)])
                }}
                style={{ width: '100%', fontSize: 12 }}
            />;
        default:
            if (placeholder.format.startsWith('OPTS:')) {
                const keys = placeholder.format.substring(5).split(',');
                return <PlattenInput
                    disabled={props.disabled}
                    value={isEmpty(props.value)
                        ? []
                        : (props.value instanceof Array
                            ? props.value
                            : props.value.split(","))}
                    onChange={props.onChange}
                    options={keys.map(opt => { return { value: opt, title: opt } })}
                />;
            } else {
                if (props.rawDate) {
                    // eslint-disable-next-line no-template-curly-in-string
                    return <Tooltip title='可以输入指定的日期(yyyy-MM-dd)或者相对日期(${dt-1}/${dt-2}/${dt-X})'>
                        <Input
                            disabled={props.disabled}
                            value={props.value}
                            allowClear
                            size="small"
                            style={{ width: '100%', fontSize: 12 }}
                            onChange={({ target: { value } }) => props.onChange(value)}
                        >
                        </Input>
                    </Tooltip>
                } else {
                    return <DatePicker
                        disabled={props.disabled}
                        value={props.value === undefined ? undefined : moment(props.value, dateFormat)}
                        onChange={date => {
                            props.onChange(isEmpty(date) ? undefined : date.format(dateFormat))
                        }}
                        onOpenChange={open => props.onOpenChange && props.onOpenChange(open)}
                        size="small"
                        style={{ width: '100%' }}
                    />;
                }
            }
    }
}

class PlaceholderInput extends React.Component {

    render() {
        const placeholder = this.props.placeholder;
        switch (placeholder.format) {
            case 'BCZ_STAFF_UID':
                return <Select
                    disabled={this.props.disabled}
                    mode="multiple"
                    allowClear
                    showSearch
                    style={{ width: '100%', minWidth: 160, fontSize: 12 }}
                    placeholder="员工"
                    value={this.props.value}
                    size="small"
                    onChange={this.props.onChange}
                >
                    {this.props.md.staffs?.map(staff => <Select.Option key={staff.id}>{staff.name}</Select.Option>)}
                </Select>;
            case 'IDENTITY':
                return <Select
                    disabled={this.props.disabled}
                    showSearch
                    value={this.props.value}
                    allowClear
                    mode="multiple"
                    size="small"
                    placeholder="请选择用户身份"
                    style={{ width: '100%', minWidth: 160 }}
                    onChange={this.props.onChange}
                >
                    {placeholderOptions.IDENTITY.map(opt => <Select.Option value={opt.value}>{opt.title}</Select.Option>)}
                </Select>;
            case 'SEX':
                return <Select
                    disabled={this.props.disabled}
                    value={this.props.value}
                    allowClear
                    showSearch
                    mode="multiple"
                    size="small"
                    placeholder="请选择性别"
                    style={{ width: '100%', minWidth: 160 }}
                    onChange={this.props.onChange}
                >
                    <Select.Option value="男">男</Select.Option>
                    <Select.Option value="女">女</Select.Option>
                    <Select.Option value="NULL">NULL</Select.Option>
                </Select>;
            case 'YES_OR_NO':
                return <Select
                    disabled={this.props.disabled}
                    value={this.props.value}
                    showSearch
                    allowClear
                    size="small"
                    style={{ width: '100%' }}
                    onChange={this.props.onChange}
                >
                    <Select.Option value="是">是</Select.Option>
                    <Select.Option value="否">否</Select.Option>
                </Select>;
            case 'PROVINCE':
                return <Select
                    disabled={this.props.disabled}
                    mode="multiple"
                    allowClear
                    showSearch
                    style={{ width: '100%', minWidth: 160 }}
                    placeholder="选择省份"
                    value={this.props.value}
                    size="small"
                    onChange={this.props.onChange}
                >
                    {this.props.md.provinces?.map(province => <Select.Option key={province.title}>{province.title}</Select.Option>)}
                    <Select.Option value="NULL">NULL</Select.Option>
                </Select>

            case 'CITY':
                return <TreeSelect
                    disabled={this.props.disabled}
                    showSearch
                    style={{ width: '100%', minWidth: 160 }}
                    value={this.props.value}
                    size="small"
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    placeholder="选择城市"
                    allowClear
                    multiple
                    treeDefaultExpandAll
                    onChange={this.props.onChange}
                >
                    {this.props.md.provinces?.map((province) =>
                        <TreeSelect.TreeNode value={province.key} title={province.title}>
                            {province.children.map(city =>
                                <TreeSelect.TreeNode value={city.title} title={city.title} />)}
                        </TreeSelect.TreeNode>)}
                </TreeSelect>;
            case 'AD_POSITION':
                return <TreeSelect
                    disabled={this.props.disabled}
                    showSearch
                    style={{ width: '100%', minWidth: 160 }}
                    value={this.props.value}
                    size="small"
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    placeholder="请选择广告位"
                    allowClear
                    multiple
                    treeDefaultExpandAll
                    onChange={this.props.onChange}
                >
                    {this.props.md.adSlots?.map((app) =>
                        <TreeSelect.TreeNode value={app.key} title={app.title}>
                            {app.children.map(slot =>
                                <TreeSelect.TreeNode value={slot.title} title={slot.title} />)}
                        </TreeSelect.TreeNode>)}
                </TreeSelect>;
            case 'BCZ_WORD_BOOK': // bookCategories
                return <TreeSelect
                    disabled={this.props.disabled}
                    showSearch
                    style={{ width: '100%', minWidth: 160, fontSize: 12 }}
                    value={this.props.value}
                    size="small"
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    placeholder="选择词书"
                    allowClear
                    multiple
                    treeDefaultExpandAll
                    onChange={this.props.onChange}
                >
                    {this.props.md.bookCategories?.map(category =>
                        <TreeSelect.TreeNode
                            value={category.key}
                            title={category.title}
                        >
                            {category.children.map(book =>
                                <TreeSelect.TreeNode
                                    key={book.key}
                                    value={book.title}
                                    title={book.title}
                                />)}
                        </TreeSelect.TreeNode>)}
                </TreeSelect>;
            case 'TO_GROUP':
                return <Select
                    disabled={this.props.disabled}
                    value={this.props.value}
                    showSearch
                    mode="multiple"
                    allowClear
                    size="small"
                    placeholder="请选择承接团队"
                    style={{ width: '100%' }}
                    onChange={this.props.onChange}
                >
                    {this.props.md.toGroupsToObjects?.map(toGroup =>
                        <Select.Option value={toGroup.key}>{toGroup.title}</Select.Option>)}
                </Select>;
            case 'TO_OBJECT':
                return <TreeSelect
                    disabled={this.props.disabled}
                    showSearch
                    style={{ width: '100%', minWidth: 160 }}
                    value={this.props.value}
                    size="small"
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    placeholder="请选择承接对象"
                    allowClear
                    multiple
                    treeDefaultExpandAll
                    onChange={this.props.onChange}
                >
                    {this.props.md.toGroupsToObjects?.map((toGroup) =>
                        <TreeSelect.TreeNode value={toGroup.key} title={toGroup.title}>
                            {toGroup.children.map(toObject =>
                                <TreeSelect.TreeNode value={toObject.key} title={toObject.title} />)}
                        </TreeSelect.TreeNode>)}
                </TreeSelect>;
            case 'FROM_GROUP':
                return <Select
                    disabled={this.props.disabled}
                    value={this.props.value}
                    showSearch
                    mode="multiple"
                    allowClear
                    size="small"
                    style={{ width: '100%' }}
                    onChange={this.props.onChange}
                >
                    {this.state.toGroupsToObjects?.map(toGroup =>
                        <Select.Option value={toGroup.key}>{toGroup.title}</Select.Option>)}
                </Select>;
            case 'MULTI_INPUT':
            case 'LIKE_INPUT':
            case 'INPUT':
                return <Input
                    disabled={this.props.disabled}
                    value={this.props.value}
                    allowClear
                    size="small"
                    style={{ width: '100%' }}
                    onChange={({ target: { value } }) => this.props.onChange(value)}
                />;
            case 'CITY_LEVEL':
                return <Select
                    disabled={this.props.disabled}
                    value={this.props.value}
                    showSearch
                    mode="multiple"
                    allowClear
                    placeholder="请选择城市等级"
                    size="small"
                    style={{ width: '100%' }}
                    onChange={this.props.onChange}
                >
                    {placeholderOptions.CITY_LEVEL.map(opt => <Select.Option value={opt.value}>{opt.title}</Select.Option>)}
                </Select>;
            // NULL
            // android
            // ipad
            // iphone
            case 'DEVICE_KIND':
                return <Select
                    disabled={this.props.disabled}
                    value={this.props.value}
                    showSearch
                    mode="multiple"
                    allowClear
                    size="small"
                    placeholder="请选择设备类型"
                    style={{ width: '100%' }}
                    onChange={this.props.onChange}
                >
                    {placeholderOptions.DEVICE_KIND.map(opt => <Select.Option value={opt.value}>{opt.title}</Select.Option>)}
                </Select>;
            case 'DEVICE_PRICE':
                return <Select
                    disabled={this.props.disabled}
                    value={this.props.value}
                    showSearch
                    mode="multiple"
                    allowClear
                    size="small"
                    placeholder="请选择设备价格区间"
                    style={{ width: '100%' }}
                    onChange={this.props.onChange}
                >
                    {placeholderOptions.DEVICE_PRICE.map(opt => <Select.Option value={opt.value}>{opt.title}</Select.Option>)}
                </Select>;
            case 'USER_GRADE':
                return <Select
                    disabled={this.props.disabled}
                    value={this.props.value}
                    showSearch
                    mode="multiple"
                    allowClear
                    size="small"
                    placeholder="请选择年级"
                    style={{ width: '100%' }}
                    onChange={this.props.onChange}
                >
                    {placeholderOptions.USER_GRADE.map(opt => <Select.Option value={opt.value}>{opt.title}</Select.Option>)}
                </Select>;
            case 'AD_KIND':
                return <Select
                    disabled={this.props.disabled}
                    value={this.props.value}
                    showSearch
                    allowClear
                    size="small"
                    placeholder="请选择广告类型"
                    style={{ width: '100%' }}
                    onChange={this.props.onChange}
                >
                    <Select.Option value="prod">正式广告</Select.Option>
                    <Select.Option value="test">实验广告</Select.Option>
                </Select>;
            case 'DATE_RANGE':
                if (this.props.rawDate) {
                    return <>
                        <Row>
                            <Col>
                                <Tooltip title='可以输入指定的日期(yyyy-MM-dd)或者相对日期(${dt-1}/${dt-2}/${dt-X})'>
                                    <Input
                                        addonBefore={<span style={{ fontSize: 12 }}>开始</span>}
                                        disabled={this.props.disabled}
                                        value={isEmpty(this.props.value) ? undefined : this.props.value[0]}
                                        allowClear
                                        size="small"
                                        style={{ width: '100%', fontSize: 12 }}
                                        onChange={({ target: { value } }) => {
                                            let newValue;
                                            if (isEmpty(this.props.value)) {
                                                newValue = [undefined, undefined];
                                            } else {
                                                newValue = [...this.props.value];
                                            }
                                            newValue[0] = value;
                                            this.props.onChange(newValue);
                                        }}
                                    />
                                </Tooltip>
                            </Col>
                        </Row>
                        <Row style={{ margin: '3px 0 0 0' }}>
                            <Col>
                                <Input
                                    addonBefore={<span style={{ fontSize: 12 }}>结束</span>}
                                    disabled={this.props.disabled}
                                    value={isEmpty(this.props.value) ? undefined : this.props.value[1]}
                                    allowClear
                                    size="small"
                                    style={{ width: '100%', fontSize: 12 }}
                                    onChange={({ target: { value } }) => {
                                        let newValue;
                                        if (isEmpty(this.props.value)) {
                                            newValue = [undefined, undefined];
                                        } else {
                                            newValue = [...this.props.value];
                                        }
                                        newValue[1] = value;
                                        this.props.onChange(newValue);
                                    }}
                                />
                            </Col>
                        </Row>
                    </>
                } else {
                    return <DatePicker.RangePicker
                        size='small'
                        value={this.props.value === undefined
                            ? undefined
                            : [moment(this.props.value[0], dateFormat), moment(this.props.value[1], dateFormat)]}
                        onChange={dates => {
                            this.props.onChange(isEmpty(dates)
                                ? undefined
                                : [dates[0].format(dateFormat), dates[1].format(dateFormat)])
                        }}
                        style={{ width: '100%', fontSize: 12 }}
                    />;
                }
            default:
                if (placeholder.format.startsWith('OPTS:')) {
                    const keys = placeholder.format.substring(5).split(',');
                    return <Select
                        disabled={this.props.disabled}
                        value={isEmpty(this.props.value)
                            ? []
                            : (this.props.value instanceof Array
                                ? this.props.value
                                : this.props.value.split(","))}
                        allowClear
                        mode="multiple"
                        size="small"
                        style={{ width: '100%', minWidth: 160 }}
                        onChange={this.props.onChange}
                    >
                        {keys.map(opt => <Select.Option value={opt}>{opt}</Select.Option>)}
                    </Select>;
                } else {
                    if (this.props.rawDate) {
                        // eslint-disable-next-line no-template-curly-in-string
                        return <Tooltip title='可以输入指定的日期(yyyy-MM-dd)或者相对日期(${dt-1}/${dt-2}/${dt-X})'>
                            <Input
                                disabled={this.props.disabled}
                                value={this.props.value}
                                allowClear
                                size="small"
                                style={{ width: '100%', fontSize: 12 }}
                                onChange={({ target: { value } }) => this.props.onChange(value)}
                            >
                            </Input>
                        </Tooltip>
                    } else {
                        return <DatePicker
                            disabled={this.props.disabled}
                            value={this.props.value === undefined ? undefined : moment(this.props.value, dateFormat)}
                            onChange={date => {
                                this.props.onChange(isEmpty(date) ? undefined : date.format(dateFormat))
                            }}
                            onOpenChange={open => this.props.onOpenChange && this.props.onOpenChange(open)}
                            size="small"
                            style={{ width: '100%' }}
                        />;
                    }

                }
        }
    }
}

export { PlaceholderInput, PlaceholderFlattenInput };